<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i> Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="['/osa-execucao']">Execução</a>
          </li>
          <li class="breadcrumb-item active"> {{ titulo }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="content-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card card-outline card-lightblue">
          <div class="card-header d-flex pb-0 flex-column">
            <h3 class="card-title mb-0">
              <i *ngIf="this.id" class="fas fa-pencil-alt pr-2"></i>
              <i *ngIf="!this.id" class="far fa-file pr-2"></i>
              {{ titulo }}
            </h3>
            <!-- Componente abas -->
            <app-osa-execucao-abas 
                [visualizar]="visualizar" 
                [id]="id"
                [model]="model"
                (abaEmitter)="mudarAba($event)">
            </app-osa-execucao-abas>
          </div>
          <!-- <div class="card-footer">
            <button type="button" class="btn btn-default btn-sm" (click)="onBack()">
              <i class="fas fa-times"></i> Fechar
            </button>
        </div> -->
        <div class="card-footer">
              <button
                type="button"
                class="btn btn-warning btn-sm mr-1"
                (click)="enviarParaAprovacao()"
                [hidden]="!permissoes.enviarParaAprovacao"
                *ngIf="!visualizar && aba === 5"
                [disabled]="!model.habilitarEnviarAprovacao || enviandoParaAprovacao">
                <i *ngIf="enviandoParaAprovacao" class="fas fa-spinner fa-spin"></i>
                <i *ngIf="!enviandoParaAprovacao" class="far fa-save"></i>

                {{ enviandoParaAprovacao ? 'Processando...' : 'Enviar para aprovação' }}
              </button>
              <button type="button" class="btn btn-default btn-sm" (click)="onBack()">
                <i class="fas fa-times"></i> Sair
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
